module.exports = __webpack_public_path__ + "static/media/bitfinex_logo 1.9f216a70.svg";